export const getError = (ex: any) =>
  ex?.response?.data?.message || "An error has occured!";
